/* eslint semi:0 */
/**
 * A way to get API endpoints from PDO.
 */
import { warn } from '../application/console'
import pageDataObject from '../application/pageDataObject'

let apiPdo = null
let apiEndpoints = null
let endpointNames = null

export function getApiEndpoints(endpointName = null) {
  apiPdo = apiPdo || pageDataObject.get('config.api', {})
  const apiKeys = Object.keys(apiPdo)
  endpointNames =
    endpointNames ||
    apiKeys.reduce(
      (accumulator, key) => ({
        ...accumulator,
        [key.toUpperCase()]: key.toUpperCase(),
      }),
      {}
    )

  apiEndpoints =
    apiEndpoints ||
    apiKeys.reduce(
      (accumulator, key) => ({
        ...accumulator,
        [key.toUpperCase()]: apiPdo[key],
      }),
      {}
    )
  if (endpointName && endpointName in apiEndpoints) {
    const url = apiEndpoints[endpointName]
    return (
      url && {
        url,
        endpointName,
      }
    )
  }
  warn(`No '${endpointName}' in apiEndpoints! Check PDO and possibly clear Redis`, {
    endpointName,
    endpointNames,
    apiEndpoints,
    apiPdo,
  })
  return {
    endpointNames,
    apiEndpoints,
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/api.js